import React from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from '../Components/Login';
import PublicRouters from './PublicRouter';
import PrivateRouters from './PrivateRouter';
import Dashboard from '../Components/Dashboard';
import AuthenticateProvider from '../Context/AuthenticateProvider';
import CustomerList from '../Components/Customers/List';
import CreateCustomer from '../Components/Customers/Create';
import UpdateCustomer from '../Components/Customers/Update';
import DriverList from '../Components/Drivers/List';
import CreateDriver from '../Components/Drivers/Create';
import UpdateDriver from '../Components/Drivers/Update';
import DriverView from '../Components/Drivers/View';
import VehicleList from '../Components/Vehicle/List';
import CreateVehicle from '../Components/Vehicle/Create';
import VehicleView from '../Components/Vehicle/View';
import UpdateVehicle from '../Components/Vehicle/Update';
import CreateRate from '../Components/Price/Create';
import RatesList from '../Components/Price/List';
import AttendanceList from '../Components/Attendance/List';
import QuotationList from '../Components/Quotation/List';
import CreateQuotation from '../Components/Quotation/Create';
import QuotationView from '../Components/Quotation/View';
import QuotationEdit from '../Components/Quotation/Update';
import DispatchList from '../Components/Dispatch/List';
import InvoiceList from '../Components/Invoices/List';
import InvoiceView from '../Components/Invoices/View';
import WorkLogAnalytics from '../Components/Reports/DeliveryHour';
import DispatchAnalytics from '../Components/Reports/DispatchReport';
import RevenueAnalytics from '../Components/Reports/RevenueReport';
import VehicleAnalytics from '../Components/Reports/VehicleReport';
import DriverLogList from '../Components/Drivers/Logs';
import CreateManualInvoice from '../Components/Invoices/Create';
import PaymentList from '../Components/Invoices/PaymentList';
import DispatchExecution from '../Components/Dispatch/Complete';
import DispatchView from '../Components/Dispatch/View';
import Docs from '../Components/Invoices/Docs';
import ManualInvoiceList from '../Components/Invoices/ExpenseList';
import ManualInvoiceExecution from '../Components/Invoices/ManualExpence';
import DriverSalary from '../Components/Drivers/Salary';
import EditRate from '../Components/Price/Update';
import EditManualInvoice from '../Components/Invoices/Update';
import VehicleExpenseReport from '../Components/Reports/Expenses';
import CustomerReport from '../Components/Reports/Customer';
import DriverJobReport from '../Components/Drivers/JobReport';
import Settings from '../Components/Settings';
import { getCookie } from '../Helpers/Utils';

const AdminOnly = ({ children }) => {
    const role = getCookie('role');
    if (role === 'staff') {
        return <Navigate to="/" replace />;
    }
    return children;
};

const index = () => {
    return (
        <React.Fragment>
            <AuthenticateProvider>
                <Router>
                    <Routes>
                        <Route element={<PublicRouters />}>
                            <Route path="/login" element={<Login />} />
                            <Route path="*" element={<Navigate to="/login" replace />} />
                        </Route>
                        <Route element={<PrivateRouters />}>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/customers" element={<CustomerList />} />
                            <Route path="/customer/add" element={<AdminOnly><CreateCustomer /></AdminOnly>} />
                            <Route path="/customers/edit/:id" element={<AdminOnly><UpdateCustomer /></AdminOnly>} />
                            <Route path="/drivers" element={<DriverList />} />
                            <Route path="/driver/logs" element={<AdminOnly><DriverLogList /></AdminOnly>} />
                            <Route path="/driver/add" element={<AdminOnly><CreateDriver /></AdminOnly>} />
                            <Route path="/drivers/edit/:id" element={<AdminOnly><UpdateDriver /></AdminOnly>} />
                            <Route path="/drivers/view/:id" element={<DriverView />} />
                            <Route path="/drivers/jobs/:id" element={<AdminOnly><DriverJobReport /></AdminOnly>} />
                            <Route path="/vehicles" element={<VehicleList />} />
                            <Route path="/vehicle/add" element={<AdminOnly><CreateVehicle /></AdminOnly>} />
                            <Route path="/vehicle/edit/:id" element={<AdminOnly><UpdateVehicle /></AdminOnly>} />
                            <Route path="/vehicle/view/:id" element={<VehicleView />} />
                            <Route path="/prices" element={<AdminOnly><RatesList /></AdminOnly>} />
                            <Route path="/price/add" element={<AdminOnly><CreateRate /></AdminOnly>} />
                            <Route path="/attendance" element={<AttendanceList />} />
                            <Route path="/attendance/edit/:id" element={<UpdateVehicle />} />
                            <Route path="/quotations" element={<QuotationList />} />
                            <Route path="/quotation/add" element={<CreateQuotation />} />
                            <Route path="/quotation/view/:id" element={<QuotationView />} />
                            <Route path="/quotation/edit/:id" element={<AdminOnly><QuotationEdit /></AdminOnly>} />
                            <Route path="/dispatch" element={<DispatchList />} />
                            <Route path="/dispatch/complete/:id" element={<DispatchExecution />} />
                            <Route path="/dispatch/view/:id" element={<DispatchView />} />
                            <Route path="/invoices" element={<InvoiceList />} />
                            <Route path="/payments" element={<AdminOnly><PaymentList /></AdminOnly>} />
                            <Route path="/invoice/add" element={<CreateManualInvoice />} />
                            <Route path="/invoice/view/:id" element={<InvoiceView />} />
                            <Route path="/invoice/edit/:id" element={<AdminOnly><EditManualInvoice /></AdminOnly>} />
                            <Route path="/invoice/docs/:id" element={<Docs />} />
                            <Route path="/driver/salary" element={<AdminOnly><DriverSalary /></AdminOnly>} />
                            <Route path="/expenses" element={<ManualInvoiceList />} />
                            <Route path="/expenses/add" element={<AdminOnly><ManualInvoiceExecution /></AdminOnly>} />
                            <Route path="/expenses/edit/:id" element={<AdminOnly><EditRate /></AdminOnly>} />
                            <Route path="/reports/delivery" element={<AdminOnly><WorkLogAnalytics /></AdminOnly>} />
                            <Route path="/reports/expenses" element={<AdminOnly><VehicleExpenseReport /></AdminOnly>} />
                            <Route path="/reports/customer" element={<AdminOnly><CustomerReport /></AdminOnly>} />
                            <Route path="/reports/revenue" element={<AdminOnly><RevenueAnalytics /></AdminOnly>} />
                            <Route path="/reports/vehicle" element={<AdminOnly><VehicleAnalytics /></AdminOnly>} />
                            <Route path="/reports/dispatch" element={<AdminOnly><DispatchAnalytics /></AdminOnly>} />
                            <Route path="/settings" element={<AdminOnly><Settings /></AdminOnly>} />
                        </Route>
                    </Routes>
                </Router>
            </AuthenticateProvider>
        </React.Fragment>
    )
}

export default index
